export const transition1 = {
  duration: 1.4,
  ease: [0.43, 0.13, 0.23, 0.96],
};
